import { render } from "./event-instances.vue?vue&type=template&id=d22d482e"
import script from "./event-instances.vue?vue&type=script&lang=js"
export * from "./event-instances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__